export const NOTETYPES = {
  FREE_NOTES: 'free',
  CHALLENGE: 'challenge',
  MODULE: 'module',
  TRACK: 'track',
  INTERNSHIP: 'internship',
  ENTREPRENEURSHIP: 'entrepreneurship',
} as const;

export type NOTE = (typeof NOTETYPES)[keyof typeof NOTETYPES];

export interface INoteFIle {
  id: string;
  createdAt: string;
  updatedAt: string;
  key: string;
  bucket: string;
  location: string;
  studentId: string;
  takenChallengeId: string;
}
